import { MotivosPausa, StatusAgente } from 'models/types'

export enum TYPES {
  TOGGLE_TOKEN = '@@navbar/TOGGLE_TOKEN',
  SET_TOKEN = '@@navbar/SET_TOKEN',
  CLEAN_TOKEN = '@@navbar/CLEAN_TOKEN',
  SET_VISUALIZACAO_TOKEN = '@@navbar/SET_VISUALIZACAO_TOKEN',
  SET_NOME_USUARIO = '@@navbar/SET_NOME_USUARIO',
  SET_USUARIO_SELECTED = '@@navbar/SET_USUARIO_SELECTED',
  CLEAN_USUARIO_SELECTED = '@@navbar/CLEAN_USUARIO_SELECTED',
  SET_USUARIOS_INSTITUICAO = '@@navbar/SET_USUARIOS_INSTITUICAO',
  TOGGLE_MODAL_ASSOCIAR_DESASSOCIAR = '@@navbar/TOGGLE_MODAL_ASSOCIAR_DESASSOCIAR',
  TOGGLE_MODAL_PAUSAR_AGENTE = '@@navbar/TOGGLE_MODAL_PAUSAR_AGENTE',
  SET_RAMAL_ASSOCIADO = '@@navbar/SET_RAMAL_ASSOCIADO',
  SET_ACAO_MODAL_ASSOCIAR_DESASSOCIAR = '@@navbar/SET_ACAO_MODAL_ASSOCIAR_DESASSOCIAR',
  SET_ACAO_MODAL_PAUSAR_AGENTE = '@@navbar/SET_ACAO_MODAL_PAUSAR_AGENTE',
  SET_MOTIVOS_PAUSA = '@@navbar/SET_MOTIVOS_PAUSA',
  SET_MOTIVO_PAUSA_ID = '@@navbar/SET_MOTIVO_PAUSA_ID',
  SET_STATUS_AGENTE = '@@navbar/SET_STATUS_AGENTE',
  SET_STATUS_AGENTE_CRONOMETRO = '@@navbar/SET_STATUS_AGENTE_CRONOMETRO',
  CLEAN_MOTIVOS_PAUSA = '@@navbar/CLEAN_MOTIVOS_PAUSA',
  DESPAUSAR_AGENTE_SUCCESS = '@@navbar/DESPAUSAR_AGENTE_SUCCESS',
  GET_STATUS_AGENTE_SUCCESS = '@@navbar/GET_STATUS_AGENTE_SUCCESS',

  ATUALIZA_TOKEN_SAGA = '@@navbar/ATUALIZA_TOKEN_SAGA',
  GET_USUARIOS_INSTITUICAO_SAGA = '@@navbar/GET_USUARIOS_INSTITUICAO_SAGA',
  GET_RAMAL_ASSOCIADO_SAGA = '@@navbar/GET_RAMAL_ASSOCIADO_SAGA',
  CONFIRMAR_ACAO_ASSOCIAR_DESASSOCIAR_SAGA = '@@navbar/CONFIRMAR_ACAO_ASSOCIAR_DESASSOCIAR_SAGA',
  CONFIRMAR_ACAO_PAUSAR_AGENTE_SAGA = '@@navbar/CONFIRMAR_ACAO_PAUSAR_AGENTE_SAGA',
  GET_MOTIVOS_PAUSA_SAGA = '@@navbar/GET_MOTIVOS_PAUSA_SAGA',
  GET_STATUS_AGENTE_SAGA = '@@navbar/GET_STATUS_AGENTE_SAGA',
  DESPAUSAR_AGENTE_SAGA = '@navbar/DESPAUSAR_AGENTE_SAGA'
}

export interface NAVBAR {
  token: string
  openToken: boolean
  visualizaToken: boolean
  nomeUsuario: string
  usuarioSelected: string
  usuariosInstiuicao: string[]
  modalAssociarDesassociar: boolean
  modalPausarAgente: boolean
  acaoModalAssociar: 'associar' | 'desassociar'
  acaoModalPausarAgente: 'pausar' | 'despausar'
  ramalAssociado: RamalAssociado
  motivosPausas: MotivosPausa[]
  motivoPausaId: string
  statusAgente: StatusAgente
}

interface RamalAssociado {
  empresa: string
  ramal: string
  associado: boolean
}
